import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
    key = 'AloHboXEDiUMvVTjguKYlZSwCcsdxFCE16FU8Rt2Xcxylw2gCzzdjnTnOnSvqqIa'
    key2 = 'AloHboXEDiUMvVTjguKYlZSwCcsdxFCE16FU8Rt2Xcxylw2gCzzdjnTnOnSvqqIa'
    
    // baseAppUrl = 'http://localhost:49394';
     // baseAppUrl = 'https://localhost:44331'; // local PC
    // baseAppUrl = 'https://alkotek.com/tppcore';
    baseAppUrl = 'https://ddt.theparkpeople.org/tppcore'; // this one Denver
    // baseAppUrl = '../tppcore';
    baseApiUrl = `${this.baseAppUrl}/api/`;
}


